import React from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import { connect } from 'react-redux';
// import ReactGA from 'react-ga';

// import queryString from 'query-string';
import { history } from './helpers';

// import { PrivateRoute } from './components/PrivateRoute';
// import { HomePage } from './containers/home';

import { HomePage } from './containers/Home';
import { AuthPage } from './containers/Auth';
import { GamesPage } from './containers/games/index';
import { GameItem } from './containers/games/item';
import { GameNew } from './containers/games/new';

// GLOBAL MODALS
import ConfirmModal from './components/ComfirmModal';

import './App.css';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    // Bindings
  }

  // componentDidMount(){}

  render() {
    return (
      <div className='container-fluid'>
        <div className='row'>
          <div id='app' className='col-12'>
            <BrowserRouter
              history={history}
              basename='/admin'
              future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <Routes>
                <Route exact path='/' element={<HomePage />} />

                <Route exact path='/authenticate' element={<AuthPage />} />

                <Route
                  exact
                  path='/logout'
                  element={() => {
                    localStorage.removeItem('scjwt');
                    history.push('/');
                    return null;
                  }}
                />

                <Route exact path='/games' element={<GamesPage />} />

                <Route exact path='/games/new' element={<GameNew />} />

                <Route path='/games/:id/*' element={<GameItem />} />
              </Routes>
            </BrowserRouter>

            <ConfirmModal />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert,
  };
}

export default connect(mapStateToProps)(App);
